import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ModalController } from '@ionic/angular';
import { ComponentProps, ComponentRef, OverlayEventDetail } from '@ionic/core';
import { ModalHandleBehavior } from '@ionic/core/dist/types/components/modal/modal-interface';
import { AlertSystemMessagesComponent } from '../../components/alert-system-messages/alert-system-messages.component';
import { ActionRolesEnum } from '@core/enums/action-roles.enum';
import { TranslateCommonService } from '@core/services/translate.service';

@Injectable({ providedIn: 'root' })
export class ModalService {
    public currentModal: HTMLIonModalElement | null = null;
    public currentModalDate: HTMLIonModalElement | null = null;

    constructor(
        private modalController: ModalController,
        private translateCommonService: TranslateCommonService,
    ) {}

    public async dismissModal() {
        if (this.currentModal) {
            await this.currentModal.dismiss(null, 'cancel');
        }

        if (this.currentModalDate) {
            await this.currentModalDate.dismiss(null, 'cancel');
        }
    }

    public openModalComponent<T extends ComponentProps<ComponentRef> = ComponentProps<ComponentRef>, R = boolean>(
        component: ComponentRef,
        componentProps?: T,
        cssClass?: string,
        backdropDismiss?: boolean,
        noPrevisionDismiss?: boolean,
        handleBehavior?: ModalHandleBehavior,
        initialBreakpoint?: number,
        backdropBreakpoint?: number,
    ): Observable<OverlayEventDetail<R>> {
        return from(
            this.modalController.create({
                component,
                componentProps,
                cssClass,
                backdropDismiss,
                handleBehavior,
                initialBreakpoint,
                backdropBreakpoint,
            }),
        ).pipe(
            switchMap(async (modal) => {
                if (!noPrevisionDismiss) {
                    this.dismissModal().then();
                    this.currentModal = modal;
                }

                await modal.present();

                return modal.onDidDismiss();
            }),
        );
    }

    public openConfirmDeleteModal(typeTitle?: string, typeDesc?: string) {
        return this.openModalComponent(
            AlertSystemMessagesComponent,
            {
                title: 'delete-modal.title',
                paramsTitle: {
                    typeTitle: this.translateCommonService.instant(typeTitle || 'common.record-2'),
                },
                paramsDescription: {
                    typeDesc: this.translateCommonService.instant(typeDesc || 'common.record'),
                },
                description: 'delete-modal.description',
                iconName: 'warning-outline',
                iconColor: 'danger',
                buttons: [
                    {
                        trigger: ActionRolesEnum.confirm,
                        title: 'common.delete',
                        color: 'danger',
                        fill: 'solid',
                    },
                    {
                        trigger: ActionRolesEnum.cancel,
                        title: 'common.cancel',
                        color: 'primary',
                        fill: 'solid',
                    },
                ],
            },
            'alert-modal ion-alert',
            false,
            true,
        );
    }
}
